import { OEMProfile } from "../../types/Profiles/oemProfile.types";

import CompanyTab from "./tabs/CompanyTab";
import IndustrialTab from "./tabs/IndustrialTab";
import ProcurementTab from "./tabs/ProcurementTab";
import ProductsTab from "./tabs/ProductsTab";
import ActivityTab from "./tabs/ActivityTab";
import { useTranslate } from "../../hooks/LanguageProvider";
import AidaAdhesionTab from "../common/AidaAdhesionTab";

interface Props {
  profile: OEMProfile;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  userId?: number | string | null;
  onProfileUpdated?: () => Promise<void> | void;
}

export default function ProfileTabs({
  profile,
  activeTab,
  setActiveTab,
  userId,
  onProfileUpdated,
}: Props) {
  const { translate } = useTranslate();

  return (
    <>
      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body p-3">
          <ul className="nav nav-pills gap-2 flex-wrap">
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "company" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("company")}
              >
                {translate("company")}
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "industrial" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("industrial")}
              >
                {translate("industrial")}
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "procurement" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("procurement")}
              >
                {translate("procurement")}
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "products" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("products")}
              >
                {translate("products")}
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "certifications" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("certifications")}
              >
                {translate("certifications")}
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "activity" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("activity")}
              >
                {translate("activity")}
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "aida_adhesion" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("aida_adhesion")}
              >
                Adhesion AIDA
              </button>
            </li>
          </ul>
        </div>
      </div>

      {activeTab === "company" && (
        <CompanyTab
          profile={profile}
          userId={userId}
          onProfileUpdated={onProfileUpdated}
        />
      )}
      {activeTab === "industrial" && (
        <IndustrialTab
          profile={profile}
          userId={userId}
          onProfileUpdated={onProfileUpdated}
        />
      )}
      {activeTab === "procurement" && (
        <ProcurementTab
          profile={profile}
          userId={userId}
          onProfileUpdated={onProfileUpdated}
        />
      )}
      {activeTab === "products" && <ProductsTab userId={userId} view="products" />}
      {activeTab === "certifications" && <ProductsTab userId={userId} view="certifications" />}
      {activeTab === "activity" && <ActivityTab profile={profile} />}
      {activeTab === "aida_adhesion" && <AidaAdhesionTab userId={userId} />}
    </>
  );
}
